import Rest from '../../Server/Rest';
import config from '../../settings/config';

// Consulta pagos realizados
export const fetchPagosRealizados = async ({
  where,
  order,
  include,
  skip = 0,
}) => {
  const params = new URLSearchParams({
    limit: 1000,
    skip,
    where: JSON.stringify(where),
    count: 1,
    order,
    include,
  });
  const res = await Rest.peticion(
    `${config.api_url}/classes/SolicitudesPagosRealizados?${params.toString()}`,
    { method: 'GET' }
  );
  return res.json();
};
